import React, { Component } from 'react';
import { connect } from 'react-redux';
import InnerPage from '../../shared/InnerPage/InnerPage';
import { ToastContainer, toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import BenefitsLadder from '../../components/BenefitsLadder/BenefitsLadder';
import BenefitsLadderSuccess from '../../components/BenefitsLadder/BenefitsLadderSuccess/BenefitsLadderSuccess'
import { getCustomerGroup, addCustomerGroup1, addCustomerGroup2, getBenefitsLadder, deleteCustomerGroup, editCustomerGroup, resetBnefitsState } from '../../store/actions/benefitsLadderActions';
import _ from 'lodash';

class BenefitsLadderContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSuccessfulyChanged: false,
      goback: true,
      tabStep: 0
    };
  }
  onTabChange=(number)=>{
    if(number!==this.state.tabStep){
      this.setState({tabStep: number})
    }
   
  }

  elementInfiniteLoad() {
    return (
      <div className='col-sm-12'>
        <div className='spinner3'>
          <div className='rect1' />
          <div className='rect2' />
          <div className='rect3' />
          <div className='rect4' />
          <div className='rect5' />
        </div>
      </div>
    );
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.benefits.editGroupData.statusCode === 200 && !this.state.dataSuccessfulyChanged) {
      this.setState({ dataSuccessfulyChanged: true });
      let id = this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1];
      let body = {
        projectId: id,
        type: "benefitsLadder"
      }
      this.props.getBenefitsLadder(body)

    }
  }
  componentWillUnmount(){
    this.props.resetBnefitsState()
  }
  goBack=()=>{
    if(this.state.goback){
      this.setState({
        goback:false
      })
    }else{
      this.setState({
        goback:true
      })
    }
  }
  render() {
    return (
      <div>
        <ToastContainer
          position="top-right"
          type="success"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
        />
        <InnerPage
          changeUserPassword={this.props.changeUserPassword}
          changePasswordResult={this.props.changePasswordResult}
          location={this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 2]}
        >
          {((!this.props.benefits.editGroupFetching && !this.state.dataSuccessfulyChanged && this.state.goback) || this.state.goback) &&
            <BenefitsLadder
              projectId={this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1]}
              getCustomerGroup={this.props.getCustomerGroup}
              benefits={this.props.benefits}
              addCustomerGroup1={this.props.addCustomerGroup1}
              addCustomerGroup2={this.props.addCustomerGroup2}
              getBenefitsLadder={this.props.getBenefitsLadder}
              deleteCustomerGroup={this.props.deleteCustomerGroup}
              editCustomerGroup={this.props.editCustomerGroup}
              goBack={this.goBack}
              tabStep={this.state.tabStep}
              onTabChange={this.onTabChange}
            />}
          {(this.props.benefits.editGroupFetching || this.props.benefits.benefitsLadderFetching)  &&
            <div>
              {this.elementInfiniteLoad()}
            </div>
          }
          { ((!this.props.benefits.editGroupFetching && this.state.dataSuccessfulyChanged && this.props.benefits.benefitsLadderFetched && !this.state.goback) ) &&
            <BenefitsLadderSuccess
              projectId={this.props.location.pathname.split('/')[this.props.location.pathname.split('/').length - 1]}
              benefits={this.props.benefits}
              goBack={this.goBack}
              resetBnefitsState= {this.props.resetBnefitsState}
              tabStep={this.state.tabStep}
              onTabChange={this.onTabChange}
            />
          }
        </InnerPage>
      </div>
    );
  }
}


function MapStateToProps(state) {
  return {
    benefits: state.benefits
  };
}

const mapDispatchToProps = (dispatch) => ({
  getCustomerGroup: (body) => (dispatch(getCustomerGroup(body))),
  addCustomerGroup1: (body) => (dispatch(addCustomerGroup1(body))),
  addCustomerGroup2: (body) => (dispatch(addCustomerGroup2(body))),
  getBenefitsLadder: (body) => (dispatch(getBenefitsLadder(body))),
  deleteCustomerGroup: (body) => (dispatch(deleteCustomerGroup(body))),
  editCustomerGroup: (body) => (dispatch(editCustomerGroup(body))),
  resetBnefitsState: () => (dispatch(resetBnefitsState()))
});

export default withRouter(connect(MapStateToProps, mapDispatchToProps)(BenefitsLadderContainer));



// WEBPACK FOOTER //
// ./src/containers/BenefitsLadder/BenefitsLadderContainer.jsx